<template>
  <div id="app">
      <transition name="fade"  mode="out-in">
          <router-view/>
      </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
}
.fade-enter{
    opacity:0;
}
.fade-enter-active{
    transition: opacity 0.3s;
}
.fade-leave{

}
.fade-leave-active{
    opacity: 0;
    transition: opacity 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue